module.exports = __webpack_public_path__ + "static/share-0cc187a76e5880589f183a97e1b64739.jpg";